// extracted by mini-css-extract-plugin
export default {"container":"rI3jxl","infoContainer":"w9Dj08","rowAndSeat":"ru0V1t","ticketInfoContainer":"Gtjynu","ticketInfoNameContainer":"BBoiLi"};